import * as types from '../constants/actionTypes';

export function fetchRealestate(payload) {
	return {
		type: types.FETCH_REALESTATE,
		payload
	}
}
export function fetchRealestateSuccess(payload) {
	return {
		type: types.FETCH_REALESTATE_SUCCESS,
		payload
	}
}
export function fetchRealestateError(error) {
	return {
		type: types.FETCH_REALESTATE_ERROR,
		error
	}
}
// Object data for either real estate, premises or residence
//
export function fetchObjectData(payload) {
	return {
		type: types.FETCH_OBJECTDATA,
		payload
	}
}
export function fetchObjectDataError(error) {
	return {
		type: types.FETCH_OBJECTDATA_ERROR,
		error
	}
}
export function fetchPremisesSuccess(payload) {
	return {
		type: types.FETCH_PREMISES_SUCCESS,
		payload
	}
}
export function fetchResidenceSuccess(payload) {
	return {
		type: types.FETCH_RESIDENCE_SUCCESS,
		payload
	}
}
//
export function fetchAreaFilters(payload) {
	return {
		type: types.FETCH_AREA_FILTERS,
		payload
	}
}
export function fetchAreaFiltersSuccess(payload) {
	return {
		type: types.FETCH_AREA_FILTERS_SUCCESS,
		payload
	}
}
export function fetchAreaFiltersError(error) {
	return {
		type: types.FETCH_AREA_FILTERS_ERROR,
		error
	}
}
//
export function fetchRentFilters(payload) {
	return {
		type: types.FETCH_RENT_FILTERS,
		payload
	}
}
export function fetchRentFiltersSuccess(payload) {
	return {
		type: types.FETCH_RENT_FILTERS_SUCCESS,
		payload
	}
}
export function fetchRentFiltersError(error) {
	return {
		type: types.FETCH_RENT_FILTERS_ERROR,
		error
	}
}
//
export function fetchSearchFilters(payload) {
	return {
		type: types.FETCH_SEARCH_FILTERS,
		payload
	}
}
export function fetchSearchFiltersSuccess(payload) {
	return {
		type: types.FETCH_SEARCH_FILTERS_SUCCESS,
		payload
	}
}
export function fetchSearchFiltersError(error) {
	return {
		type: types.FETCH_SEARCH_FILTERS_ERROR,
		error
	}
}
//
export function setViewstate(key, value){
	return {
		type: types.VIEWSTATE_SET,
		payload: { key, value }
	}
};
export function setEmptyObjectState(key, value){
	return {
		type: types.EMPTYOBJECTSTATE_SET,
		payload: { key, value }
	}
};

export function fetchGlobalSearch(payload) {
	return {
		type: types.FETCH_GLOBAL_SEARCH,
		payload
	}
}
export function fetchGlobalSearchSuccess(payload) {
	return {
		type: types.FETCH_GLOBAL_SEARCH_SUCCESS,
		payload
	}
}
export function fetchGlobalSearchError(error) {
	return {
		type: types.FETCH_GLOBAL_SEARCH_ERROR,
		error
	}
}



// WEBPACK FOOTER //
// ./src/js/actions/actionCreators.js